import { Injectable } from '@angular/core';
import { BaseSupportScriptService } from '../../base-support-script-service';
import { IGliaUserInfo } from './glia-user-info.interface';

@Injectable({ providedIn: 'root' })
export class GliaService extends BaseSupportScriptService {
    public readonly scriptIdentifier: string = 'glia';

    public loadScript<IGliaUserInfo>(userInfo?: IGliaUserInfo): void {
        // Check if the script is already loaded
        const existingScript = document.head.querySelector(`script[data-script-identifier="${ this.scriptIdentifier }"]`);
        if (existingScript) {
            this.unloadScript();
        }

        // Create a new script element
        const script = document.createElement('script');
        if (userInfo) {
            // User information is available, use the detailed script integration
            script.text = this.generateAdvancedScript(userInfo);
        } else {
            // Default script integration without user information
            script.async = true;
            script.src = 'https://api.glia.com/salemove_integration.js';
        }

        script.setAttribute('data-script-identifier', this.scriptIdentifier);
        document.head.appendChild(script);
    }

    public unloadScript(): void {
        super.unloadScript();

        document.querySelectorAll('script[src*="salemove"], link[href*="salemove"], #salemove')
                .forEach(el => el.remove());

        // let sm = (window as any).sm;
        // if (sm) {
        //     // sm.App?.reqres?.removeHandler();
        //     sm.logger = undefined;
        //     sm = undefined;
        // }
        //
        // (window as any).installGlia = undefined;
        // sessionStorage.removeItem('sm.tab_ids');
    }

    private generateAdvancedScript(userInfo: IGliaUserInfo): string {
        const userInfoScriptPart = this.generateUserInfoScriptPart(userInfo);
        return `
      var installGlia = function(callback) {
        !function(a,b,c,d){
          var e = a.createElement(b), f = a.getElementsByTagName(b)[0];
          e.async = 1;
          e.src = c;
          e.type = "text/javascript";
          e.setAttribute('data-script-identifier', '${ this.scriptIdentifier }');
          d && e.addEventListener("load", d);
          f.parentNode.insertBefore(e, f);
        }(document, "script", "https://api.glia.com/salemove_integration.js", callback);
      };
      installGlia(function() {
        sm.getApi({version: 'v1'}).then(function(glia) {
          glia.updateInformation(${ userInfoScriptPart }).then(function() {
            // Callback fired after the Visitor Information has been successfully updated
          }).catch(function(error) {
            // Callback fired when the request for updating the Visitor Information fails
          });
        });
      });
    `;
    }

    private generateUserInfoScriptPart(userInfo?: IGliaUserInfo): string {
        if (!userInfo) { return '{}'; }

        const parts = Object.keys(userInfo).filter(key => userInfo[key] !== undefined)
                            .map(key => {
                                const value = userInfo[key];
                                if (value === undefined || value === null) {
                                    return `${ key }: ""`;
                                }

                                if (typeof value === 'object') {
                                    const subParts = Object.entries(value)
                                                           .map(([subKey, subValue]) => `${ subKey }: "${ subValue }"`);
                                    return `${ key }: { ${ subParts.join(', ') } }`;
                                }

                                return `${ key }: "${ value }"`;
                            });

        return `{ ${ parts.join(', ') } }`;
    }
}
